import axios from "../../lib/axios";
import { IFilter } from "../../types/filters.types";
import checkIsLocalhost from "../../utils/checkIsLocalhost";

const baseUrl = process.env.REACT_APP_API_BASE_URL || "/";

export const getRetailAdjustmentsData = (filters: IFilter): Promise<any> => {
  const isLocalhost = checkIsLocalhost();

  const raw = `{
    getRetailAdjustments(MViewInput: {DCDivision: ${filters.warehouseDivision}, DistributionCenter: ${filters.distribution}, Warehouse: ${filters.warehouse}, RetailDivision: ${filters.retailDivision}, RetailStore: ${filters.retailStore}, SMIC: ${filters.smic}, CIC: "${filters.cic}", UPC: ${filters.upc}, Department: ${filters.department}, RetailSection: ${filters.retailSection}})
    {
      adjustments {
        adjustmentType
        qty
      }
      errors { errorCode errorDescription }
    }
  }`;
  const url = `${baseUrl}sdiminventory/mview`;

  return axios.post(
    isLocalhost ? "/api/middleware" : url,
    isLocalhost ? { raw, url } : raw,
  );
};
